import SvgIcon from '@material-ui/core/SvgIcon';

export default function ColorMapEdit(props:any) {
  return (
    <SvgIcon viewBox='0 0 18 17' { ...props}>
      <path d="M8.18182 14.5714V16.1905H1.63636C0.736364 16.1905 0 15.4619 0 14.5714V1.61905C0 0.728571 0.736364 0 1.63636 0H16.3636C17.2636 0 18 0.728571 18 1.61905V8.17619L17.8364 8.01429C17.4273 7.60952 16.9364 7.36667 16.3636 7.36667V3.2381H1.63636V14.5714H8.18182ZM16.6909 9.14762L17.7545 10.2C17.9182 10.3619 17.9182 10.6857 17.7545 10.8476L16.9364 11.6571L15.2182 9.95714L16.0364 9.14762C16.1182 9.06667 16.2 8.98571 16.3636 8.98571C16.5273 8.98571 16.6091 9.06667 16.6909 9.14762ZM16.4455 12.0619L11.5364 17H9.81818V15.3L14.8091 10.3619L16.4455 12.0619Z" fill="currentColor"/>
    </SvgIcon>
  );
}